// extracted by mini-css-extract-plugin
export default {"container":"qK-z","dimension":"rK-z","dimensionLabels":"sK-z"};